import { convertToHTML } from "draft-convert";

const editorToHTML = convertToHTML({
  blockToHTML: (block) => {
    if (block.type === "code-block" || block.type === "code") {
      return { start: "<pre>", end: "</pre>" };
    }
  },
  entityToHTML: (entity, originalText) => {
    if (entity.type === "LINK") {
      return `<a href="${entity.data.url}" target="_blank" rel="noopener noreferrer">${originalText}</a>`;
    }
    return originalText;
  },
});

export default editorToHTML;
